<div class="flex flex-col">
  <div class="w-full h-40 bg-neutral-300 animate-pulse"></div>
  <div class="m-5">
    <div class="w-3/4 h-8 bg-neutral-200 animate-pulse mb-3"></div>
    <div class="w-2/3 h-6 bg-neutral-50 animate-pulse mb-3"></div>
    <div class="w-1/2 h-6 bg-neutral-50 animate-pulse mb-3"></div>
  </div>
</div>
